import { render, staticRenderFns } from "./RoadmapsList.vue?vue&type=template&id=2345952a&"
import script from "./RoadmapsList.vue?vue&type=script&lang=js&"
export * from "./RoadmapsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports